import { rewardService } from '@/api'
import { REFETCH_INTERVAL } from '@/constants'
import { IUser } from '@/interface'
import { Loading } from '@/ui'
import { TitleBar } from '@/ui/titlebar'
import { ACTIVE_CURRENCY, queryClient } from '@/utils'
import { useMutation, useQuery } from '@tanstack/react-query'
import Board from './board'
import MeCard from './mecard'
import { Button } from '@/cn/ui/button'
import { useToast } from '@/cn/ui/use-toast'
import { popup } from '@/popup_handler'
const LeaderboardScreen = () => {
  const { toast } = useToast()

  const { username } = queryClient.getQueryData(['user']) as IUser

  const myPoints = useQuery(['MyPoints'], () => rewardService.MyPoints(), {
    refetchInterval: REFETCH_INTERVAL,
  })
  const board = useQuery(['LeaderboardPoints'], () => rewardService.Leaderboard(), {
    refetchInterval: REFETCH_INTERVAL,
  })
  const mutation = useMutation(() => rewardService.ClaimPointsReward(), {
    async onError(error: any) {
      toast({
        variant: 'destructive',
        title: error.message,
      })
    },
    onSuccess: (res) => {
      queryClient.invalidateQueries(['MyPoints'])
      import('canvas-confetti').then((m) => {
        m.default()
      })
      popup.open('information', {
        title: `You just claimed ${ACTIVE_CURRENCY.symbol} ${ACTIVE_CURRENCY.conversion_rate * res.result.res.amount} Cray Rewards`,
        description: 'Congrats! Keep climbing.',
        icon: () => <p className="text-6xl">🎉</p>,
      })
    },
  })
  if (myPoints.isLoading) {
    return (
      <div className="h-full bg-bakground text-foreground flex items-center justify-center gap-4 flex-col">
        <Loading className="fill-primary h-24" />
      </div>
    )
  }
  const me = myPoints.data?.result ?? {}
  const rows = [...(board?.data?.result?.leaderboard || [])]
  return (
    <div className="flex flex-col gap-4 h-full w-full">
      <div className="p-4 flex flex-col gap-4 ">
        <TitleBar />
        <h2>Leaderboard</h2>
        <MeCard mana={me.mana ?? 0} rank={me.rank ?? null} minToClaim={me.minManaToClaim ?? 2000} canClaim={me.canClaim} onClaim={() => {}} claims={me.claims} />
        {me.canClaim ? (
          <Button onClick={() => mutation.mutate()} loading={mutation.isPending}>
            Claim
          </Button>
        ) : null}
      </div>
      <div className="px-4 pb-6 overflow-scroll">
        {board.isLoading ? (
          <div className="flex justify-center py-10">
            <Loading className="fill-primary h-16" />
          </div>
        ) : (
          <Board meId={username} rows={rows} />
        )}
      </div>
    </div>
  )
}
export default LeaderboardScreen
